import React from "react";
import { Button, Space } from "antd";
import { NavLink } from "react-router-dom";
import { useContext } from "react";
import { context } from "../../context/context";
import LinksTable from "./LinksTable";
const Links = () => {
    // context
    const {
        setLinkCover,
        setLinkMedia,
        setNewLinks,
        setTextEditorHTML,
        setLinkestanIcon,
        setLinkTitle,
        setLinkestanTags,
        setSelectedLinkId,
        setLinkCoverId,
    } = useContext(context);
    // functions
    const handleEmptyFields = () => {
        setLinkTitle("");
        setLinkCover([]);
        setLinkMedia([]);
        setNewLinks([]);
        setLinkCoverId();
        setTextEditorHTML("");
        setLinkestanIcon();
        setLinkestanTags([]);
        setSelectedLinkId();
    };
    return (
        <>
            <Space
                direction="vertical"
                style={{ width: "100%", justifyContent: "space-between" }}
                align="end"
            >
                <NavLink to="/addLink">
                    <Button onClick={handleEmptyFields} type="primary">
                        اضافه کردن لینک جدید
                    </Button>
                </NavLink>
            </Space>
            <LinksTable />
        </>
    );
};

export default Links;
